import React, { PropsWithChildren } from 'react';
import { Intent } from '@blueprintjs/core';
import { Callout, Flex, Icon } from 'core/components';

type PlanCalloutWrapperProps = PropsWithChildren<{
  icon: string;
  intent: Intent;
}>;

const PlanCalloutWrapper = ({ icon, intent, children }: PlanCalloutWrapperProps): JSX.Element => (
  <Callout intent={intent} mt={2}>
    <Flex flexDirection="row" alignItems="center">
      <Icon icon={icon} color={intent} mr={2} />
      <Flex flexDirection="column">{children}</Flex>
    </Flex>
  </Callout>
);

export default PlanCalloutWrapper;
